import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/sites';
import { ResultState } from '@rootCommon/types/common';
import { Site } from '@rootCommon/types/site';

type Action = ActionType<typeof actions>;
export type SiteState = ResultState<Site | null>;

const initState: SiteState = {
  data: null,
  loading: false,
  error: null,
};

export const sitesItemReducer = (state = initState, action: Action): SiteState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchSite.request):
      return { ...state, loading: true };
    case getType(actions.fetchSite.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchSite.failure):
      return { ...state, loading: false, error: action.payload };

      // create
    case getType(actions.createSite.request):
      return { ...state, loading: true };
    case getType(actions.createSite.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.createSite.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateSite.request):
      return { ...state, loading: true };
    case getType(actions.updateSite.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateSite.failure):
      return { ...state, loading: true, error: action.payload };

      // delete
    case getType(actions.deleteSite.request):
      return { ...state, loading: true };
    case getType(actions.deleteSite.success):
      return { ...state, loading: false, data: null };
    case getType(actions.deleteSite.failure):
      return { ...state, loading: true, error: action.payload };

      // default
    default:
      return state;
  }
};

export default sitesItemReducer;
